Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _Shimmer = require('./Shimmer');

var _Shimmer2 = _interopRequireDefault(_Shimmer);

var _withLoading = require('./withLoading');

var _withLoading2 = _interopRequireDefault(_withLoading);

var _textlike = require('../utils/propTypes/textlike');

var _textlike2 = _interopRequireDefault(_textlike);

var _airmojiAdjacent = require('../utils/propTypes/airmojiAdjacent');

var _headingLevelRange = require('../utils/propTypes/headingLevelRange');

var _headingLevelRange2 = _interopRequireDefault(_headingLevelRange);

var _idProp = require('../utils/propTypes/idProp');

var _idProp2 = _interopRequireDefault(_idProp);

var _headingLevels = require('../utils/headingLevels');

var _withStyles = require('../themes/withStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, _withLoading.withLoadingPropTypes, {
  children: (0, _airbnbPropTypes.or)([_airmojiAdjacent.textlikeAdjacentToAirmojiBefore, _airmojiAdjacent.textlikeAdjacentToAirmojiAfter, _textlike2['default']]),
  headingRef: _propTypes2['default'].func,
  id: _idProp2['default'],
  inline: _propTypes2['default'].bool
}));

var defaultProps = {
  headingRef: function () {
    function headingRef() {}

    return headingRef;
  }(),

  inline: false
};

var contextTypes = {
  headingLevel: _headingLevelRange2['default'].isRequired,
  hasHeadingAncestor: _propTypes2['default'].bool
};

var childContextTypes = {
  hasHeadingAncestor: _propTypes2['default'].bool.isRequired
};

var SHIMMER = _react2['default'].createElement(_Shimmer2['default'], null);

var Heading = function (_React$Component) {
  _inherits(Heading, _React$Component);

  function Heading() {
    _classCallCheck(this, Heading);

    return _possibleConstructorReturn(this, (Heading.__proto__ || Object.getPrototypeOf(Heading)).apply(this, arguments));
  }

  _createClass(Heading, [{
    key: 'getChildContext',
    value: function () {
      function getChildContext() {
        return {
          hasHeadingAncestor: true
        };
      }

      return getChildContext;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            css = _props.css,
            children = _props.children,
            headingRef = _props.headingRef,
            id = _props.id,
            inline = _props.inline,
            styles = _props.styles,
            isLoading = _props.isLoading;
        var _context = this.context,
            headingLevel = _context.headingLevel,
            hasHeadingAncestor = _context.hasHeadingAncestor;


        if (!headingLevel) {
          throw new Error('No `headingLevel` context was passed to `<Heading />`. Make sure you are using this inside of a `<HeadingSection />` component.');
        }

        if (hasHeadingAncestor) {
          throw new Error('It looks like you’re trying to render a `Heading` from within another `Heading` component.');
        }

        // <h1>, <h2>, <h3>, <h4>, <h5>, <h6>
        var HeadingTag = _headingLevels.headingTags[headingLevel - 1];

        return isLoading ? SHIMMER : _react2['default'].createElement(
          HeadingTag,
          _extends({
            id: id,
            ref: headingRef,
            tabIndex: headingRef === defaultProps.headingRef ? null : '-1'
          }, css(styles.heading, inline && styles.inline)),
          children
        );
      }

      return render;
    }()
  }]);

  return Heading;
}(_react2['default'].Component);

Heading.componentCategory = 'Core';
Heading.displayName = 'Heading';


Heading.propTypes = propTypes;
Heading.defaultProps = defaultProps;
Heading.contextTypes = contextTypes;
Heading.childContextTypes = childContextTypes;

exports['default'] = (0, _withStyles.withStyles)(function () {
  return {
    // We have some global h# selectors that provide some basic styles to heading
    // tags that we do not want to inherit here, so we need to override them to
    // allow the heading prop to be appropriately styled. This allows us to
    // separate our semantic markup from how it is styled.
    //
    // I determined which styles to set here, partly based on these styles:
    //
    // - https://git.musta.ch/airbnb/o2/blob/98e39eab/src/scss/modules/_typography.scss#L89-L108
    // - https://git.musta.ch/airbnb/o2/blob/3b79fd24/src/scss/o2-mixins.scss#L153-L194
    heading: {
      color: 'inherit',
      fontSize: '1em',
      fontWeight: 'inherit',
      lineHeight: 'inherit',
      margin: 0,
      padding: 0
    },

    inline: {
      display: 'inline'
    }
  };
})((0, _withLoading2['default'])(Heading));


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Heading.js
// module id = 244
// module chunks = 168707334958949